import React from 'react'
import Navbars from '../Utility/Navbars'
import ServicesLang from '../Home/ServicesLang'
import bannerImage from "../Images/create.png"
import ApplyNowLang from '../Home/ApplyNowLang'
// import Slider from '../Home/Slider'
import FooterLang from '../Home/FooterLang'
import Marquee from '../Home/Marquee'
import CompanyLang from '../Home/CompanyLang'
import CardSliderLang from '../Home/CardSliderLang'
import goldVideo from "../Images/video.mp4"
import { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from 'swiper/modules';
// Import Swiper styles
import "swiper/css";
import "./Home.css";
import sliderOne from '../Images/sliderNew/anjaliweb.jpg'
import sliderTwo from '../Images/sliderNew/ganeshaweb.jpg'
import sliderThree from '../Images/sliderNew/malvikaweb.jpg'
import sliderFour from '../Images/sliderNew/sudharani.jpg'
import OnLoadPopup from '../components/onLoadPopup'

function HomeLang() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  return (
    <>
      <Navbars />
      <OnLoadPopup/>
      {/* <section className="showcase" >
        <video className='banner-video'
          loop
          muted
          autoPlay={isVideoPlaying}
          playsInline
          webkit-playsInline
        >
          <source src={goldVideo} type="video/mp4" />
        </video>
        <div className="overlay">
        </div>
        <CompanyLang />

      </section> */}
      <section>
        <div className='banner-slider-fUll'>
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 3000,       // Slide every 3 seconds
              disableOnInteraction: false, // Keeps autoplay after user interaction
            }}
            loop={true}
            spaceBetween={30}
            slidesPerView={1}
          >
            <SwiperSlide><img className='img-fluid' src={sliderOne} /></SwiperSlide>
            <SwiperSlide><img className='img-fluid' src={sliderTwo} /></SwiperSlide>
            <SwiperSlide><img className='img-fluid' src={sliderThree} /></SwiperSlide>
            <SwiperSlide><img className='img-fluid' src={sliderFour} /></SwiperSlide>
          </Swiper>
          {/* <div className="overlaySlider"></div> */}
          <div className='homePageFloatin'>
            <CompanyLang />
          </div>
        </div>
      </section>
      <ServicesLang />
      <section className='full-width-calculate'>
        <img src={bannerImage} alt='full-img' className="img-fluid img-cal" />
        <img src={bannerImage} alt='full-img' className="img-fluid img-cal-mob" />
        <div className='calculate-now-btn'> <a href='/calculator' className='text-decoration-none'>Calculate Now</a></div>
      </section>
      <ApplyNowLang />
      <CardSliderLang />
      <FooterLang />
      <Marquee />
    </>
  )
}

export default HomeLang

